var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("About")]),_c('v-col',[_c('p',[_vm._v("Redirecting to "),_c('a',{attrs:{"href":"https://wikiba.se/about-us/"}},[_vm._v("https://wikiba.se/about-us/")])])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }